import { render, staticRenderFns } from "./finaceOrderDetails.vue?vue&type=template&id=c843b936&scoped=true&"
import script from "./finaceOrderDetails.vue?vue&type=script&lang=js&"
export * from "./finaceOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./finaceOrderDetails.vue?vue&type=style&index=0&id=c843b936&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c843b936",
  null
  
)

export default component.exports